import QualityBadge from "./QualityBadge";
import AdminTableContainer from "../layout/AdminTableContainer";

function formatRunStatus(status) {
  if (!status) {
    return "—";
  }

  return status.replace(/_/g, " ");
}

const RealEstateSourceTable = ({ sources, selectedSourceCode, onSelectSource }) => {
  if (!sources?.length) {
    return <p className="muted">No real estate sources found.</p>;
  }

  const table = (
    <table className="admin-data-health-table">
      <thead>
        <tr>
          <th>Source</th>
          <th>Type</th>
          <th>Latest run</th>
          <th>Status</th>
          <th>Properties</th>
          <th>Mapped</th>
          <th>Missing coords</th>
          <th>Missing price</th>
          <th>Stale</th>
          <th>Duplicates</th>
          <th>Last success</th>
          <th>Health</th>
        </tr>
      </thead>
      <tbody>
        {sources.map((source) => {
          const isSelected = source.sourceCode === selectedSourceCode;

          return (
            <tr
              key={source.sourceCode}
              className={isSelected ? "admin-re-source-row--selected" : ""}
            >
              <td>
                <button
                  type="button"
                  className="admin-re-source-link"
                  onClick={() => onSelectSource(source.sourceCode)}
                >
                  {source.sourceName}
                </button>
                <div className="muted admin-re-source-code">{source.sourceCode}</div>
              </td>
              <td>{source.sourceType}</td>
              <td>{source.latestRunCompletedAt || source.latestRunStartedAt || "—"}</td>
              <td>{formatRunStatus(source.latestRunStatus)}</td>
              <td>{source.totalProperties}</td>
              <td>
                {source.mappedProperties}
                {source.mappedPercent ? ` (${source.mappedPercent}%)` : ""}
              </td>
              <td>{source.missingCoordinates}</td>
              <td>{source.missingPrice}</td>
              <td>{source.staleProperties}</td>
              <td>{source.possibleDuplicateCount}</td>
              <td>{source.lastSuccessfulRunAt || "—"}</td>
              <td>
                <QualityBadge health={source.health} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  return <AdminTableContainer>{table}</AdminTableContainer>;
};

export default RealEstateSourceTable;
